<template>
  <div class="search-form">
    <div class="search-form__input--wrap">
      <input
        type="text"
        :value="value"
        :placeholder="placeholder"
        class="search-form__input--text"
        :class="{
          'input-form': !isValueInputted,
          'input-form--inputted': isValueInputted || isTextInputFocused,
          'input-form--inputting': isTextInputFocused
        }"
        enterkeyhint="search"
        @input="onInput"
        @keydown.enter="onSearchKeyword"
        @focus="onFocusKeyword"
        @blur="onBlurKeyword"
      />
      <button
        class="search-form__input--clear"
        :class="{
          'search-form__input--clear--active': isValueInputted
        }"
        @click="onClickClearKeyword"
      >
        <CloseCircle />
      </button>
    </div>
    <button class="search-form__button" @click="onClickSearchKeyword">
      <MagnifyingGlass />
    </button>
  </div>
</template>
<script>
import MagnifyingGlass from '../../atoms/svg_icons/MagnifyingGlass.vue'
import CloseCircle from '../../atoms/svg_icons/CloseCircle.vue'
import { debounce } from 'lodash'

const ONINPUT_DEBOUNCE_TIME = 1
const ENTER_KEY_CODE = 13

export default {
  components: { MagnifyingGlass, CloseCircle },
  props: {
    value: {
      type: String,
      default: '',
      required: true
    },
    placeholder: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isTextInputFocused: false
    }
  },
  computed: {
    isValueInputted() {
      return this.value.length !== 0
    }
  },
  methods: {
    // [iPhoneのみ?]変換時のinputイベントが「ねこ(変換中)」→「猫(変換確定)」の時、
    // 「ねこ」→「」→「猫」と空文字を経由する問題があるため、
    // debounceで刹那的なタイミングの空文字は処理しないように
    onInput: debounce(function (e) {
      this.$emit('input-search-keyword', e.target.value)
    }, ONINPUT_DEBOUNCE_TIME),
    onFocusKeyword() {
      this.isTextInputFocused = true
      this.$emit('on-focus')
    },
    onBlurKeyword() {
      this.isTextInputFocused = false
      this.$emit('on-blur')
    },
    onClickClearKeyword() {
      this.$emit('clicked-clear-keyword')
    },
    onSearchKeyword(event) {
      if (event.keyCode !== ENTER_KEY_CODE) return
      this.$emit('clicked-search-keyword')
    },
    onClickSearchKeyword() {
      this.$emit('clicked-search-keyword')
    }
  }
}
</script>
<style lang="scss" scoped>
.search-form {
  display: flex;
  width: 100%;

  &__input {
    &--wrap {
      position: relative;
      width: 100%;
    }

    &--text {
      padding-right: 38px;
      height: 40px;
      border-radius: 8px 0 0 8px;
      font-size: 14px;
      ::placeholder {
        font-size: 14px;
      }
    }

    &--clear {
      display: none;
      &--active {
        display: block;
        position: absolute;
        cursor: pointer;
        width: 20px;
        height: 20px;
        right: 10px;
        top: 10px;
      }
    }
  }

  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0 8px 8px 0;
    padding: 8px;
    background-color: $gray-2;
    cursor: pointer;
    height: 40px;
    width: 40px;
  }
}
</style>
